module.exports = __webpack_public_path__ + "img/map4.2e68e790.jpg";